import React, { useState } from "react";
import { FaInstagram, FaTelegramPlane, FaEnvelope } from "react-icons/fa";
import {
  AiOutlineHome,
  AiOutlineSolution,
  AiOutlineRead,
  AiOutlinePhone,
} from "react-icons/ai";
import logo from "../assets/images/logo.png";
import { motion } from "framer-motion";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 300);
  };

  return (
    <header className="header">
      <a href="" className="header__logo">
        <img className="header__icon" src={logo} alt="Логотип" />
      </a>

      <motion.button
        className="header__burger"
        aria-label="Меню"
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <motion.div
          className="burger__icon"
          animate={isOpen ? "open" : "closed"}
          variants={{
            open: { rotate: 22 },
            closed: { rotate: 0 },
          }}
        >
          <motion.span
            variants={{
              open: { rotate: 32, y: 8 },
              closed: { rotate: 0, y: 0 },
            }}
          />
          <motion.span
            variants={{
              open: { opacity: 0 },
              closed: { opacity: 1 },
            }}
          />
          <motion.span
            variants={{
              open: { rotate: -72, y: -8 },
              closed: { rotate: 0, y: 0 },
            }}
          />
        </motion.div>
      </motion.button>

      <nav className={`menu ${isOpen ? "menu--open" : ""}`}>
        {/* Соцсети */}
        <div className="menu__top">
          <a href="" className="menu__square">
            <FaInstagram />
            <p>INSTAGRAM</p>
          </a>
          <a href="" className="menu__square">
            <FaTelegramPlane />
            <p>TELEGRAM</p>
          </a>
          <a href="" className="menu__square">
            <FaEnvelope />
            <p>GMAIL</p>
          </a>
        </div>

        {/* Центральная кнопка */}
        <div className="menu__center">
          <a href="" className="menu__cta">
            <span className="menu__cta-text">ПРИЄДНАТИСЬ ДО НАС</span>
            <span className="menu__cta-plus">+</span>
          </a>
        </div>

        {/* Основные ссылки внизу в квадратах */}
        <div className="menu__bottom">
          <a href="" className="menu__square">
            <AiOutlineHome />
            <p>ГОЛОВНА</p>
          </a>
          <a href="" className="menu__square">
            <AiOutlineSolution />
            <p>НОВАЧКАМ</p>
          </a>
          <a href="" className="menu__square">
            <AiOutlineRead />
            <p>ТАРИФИ</p>
          </a>
          <a href="" className="menu__square">
            <AiOutlinePhone />
            <p>КОНТАКТИ</p>
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Header;
